import { createSlice } from "@reduxjs/toolkit";
import { toggleBookmark, getMyBookmarks } from "./thunk";
import { toggleLike } from "../5-like/thunk";

const initialState = {
  bookmarks: [],
  loading: false,
  error: null,
  pagination: {
    currentPage: 1,
    pageSize: 10,
    totalPages: 1,
    totalCount: 0,
    hasNextPage: false,
    hasPrevPage: false,
  },
};

const bookmarkSlice = createSlice({
  name: "bookmark",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // ========================
      // TOGGLE LIKE
      // ========================
      .addCase(toggleBookmark.pending, (state) => {
        state.loading = true;
      })
      // .addCase(toggleBookmark.fulfilled, (state, action) => {
      //   state.loading = false;
      // })
      .addCase(toggleBookmark.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(toggleBookmark.fulfilled, (state, action) => {
        const postId = action.meta.arg;

        state.bookmarks = state.bookmarks.filter((post) => post.id !== postId);
      })

      // ========================
      // TOGGLE LIKE (LISTEN FROM HOME POSTS)
      // ========================
      .addCase(toggleLike.fulfilled, (state, action) => {
        const postId = action.meta.arg;
        const { liked } = action.payload;

        const post = state.bookmarks.find((p) => p.id === postId);
        if (post) {
          post.liked = liked;
          post.likeCount += liked ? 1 : -1;
        }

        if (state.post && state.post.id === postId) {
          state.post.liked = liked;
          state.post.likeCount += liked ? 1 : -1;
        }
      })

      .addCase(getMyBookmarks.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMyBookmarks.fulfilled, (state, action) => {
        state.loading = false;
        const data = action.payload.data || [];

        if (action.meta.arg.page > 1) {
          state.bookmarks = [...state.bookmarks, ...data];
        } else {
          state.bookmarks = data;
        }

        if (action.payload.responseDetails?.pagination) {
          state.pagination = action.payload.responseDetails.pagination;
        }
      })

      .addCase(getMyBookmarks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default bookmarkSlice.reducer;
